import { render, staticRenderFns } from "./EventReportListField.vue?vue&type=template&id=0954f827&scoped=true"
import script from "./EventReportListField.vue?vue&type=script&lang=ts"
export * from "./EventReportListField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0954f827",
  null
  
)

export default component.exports